export class NaturalGasUseType {
	public id: number;
	public name: string;

	constructor(naturalGasUseType?: NaturalGasUseType) {
		Object.assign(this, naturalGasUseType);
	}
}
